import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { filterBoolean } from '@recruitee/common';
import { createEffectFactory } from '@recruitee/ngrx';

import { FeatureFlagsHttpService } from './feature-flags-http.service';
import { FeatureFlagEntityActions } from './feature-flags.store';

@Injectable({ providedIn: 'root' })
export class FeatureFlagsEffects {
  public effects = createEffectFactory(FeatureFlagEntityActions, this.actions$);

  public loadFeatureFlags$ = this.effects(FeatureFlagEntityActions.fetch, () =>
    this.featureFlagsHttpService.fetch().pipe(filterBoolean),
  );

  constructor(
    private actions$: Actions,
    private featureFlagsHttpService: FeatureFlagsHttpService,
  ) {}
}
